import { semanticColors, typography } from '@moderneinc/design-system-tokens';
import { styled, Typography } from '@mui/material';

export const OverflowMenuCaption = styled(Typography)({
  fontSize: typography.fontSize.xs,
  color: semanticColors.color.text.secondary,
  lineHeight: 1.4
});
